import type { FC } from "react";

import type { FlowScreenConfig, FlowCustomComponentProps } from "@/shared/constants/flowTypes";

import { OtherDebtsChecklist, ALL_DEBT_KEYS, NONE_VALUE } from "../components/OtherDebtsChecklist";
import { AddOtherDebt } from "../components/AddOtherDebt";
import { OtherDebtsReview } from "../components/OtherDebtsReview";
import { createModuleComplete } from "@/pages/postloss/modules/components/ModuleComplete";

function createAddWrapper(debtKey: string): FC<FlowCustomComponentProps> {
  const Wrapper: FC<FlowCustomComponentProps> = (props) => (
    <AddOtherDebt {...props} debtKey={debtKey} />
  );
  return Wrapper;
}

function createAddScreen(debtKey: string): FlowScreenConfig {
  return {
    id: `add_other_debt_${debtKey}`,
    layout: "full",
    maxWidth: "4xl",
    hideButton: true,
    customComponent: createAddWrapper(debtKey),
    shouldDisplay: ({ answers }) => {
      const selected = Array.isArray(answers["other_debts_selected"])
        ? answers["other_debts_selected"]
        : [];
      return (
        selected.includes(debtKey) &&
        !selected.includes(NONE_VALUE) &&
        answers[`other_debt_${debtKey}_done`] !== "yes" &&
        answers[`other_debt_${debtKey}_done`] !== "skipped"
      );
    },
  };
}

export function createOtherDebtsScreens(firstName: string): FlowScreenConfig[] {
  return [
    {
      id: "other_debts_checklist",
      layout: "full",
      textAlign: "center",
      maxWidth: "2xl",
      title: `Did ${firstName} have any of these other debts?`,
      subtitle: `These don't come up in every estate. Select anything that applies to ${firstName}.`,
      hideButton: true,
      customComponent: OtherDebtsChecklist,
    },
    ...ALL_DEBT_KEYS.map((key) => createAddScreen(key)),
    {
      id: "other_debts_review",
      layout: "full",
      textAlign: "center",
      maxWidth: "2xl",
      hideButton: true,
      customComponent: OtherDebtsReview,
      shouldDisplay: ({ answers }) => {
        const selected = Array.isArray(answers["other_debts_selected"])
          ? answers["other_debts_selected"]
          : [];
        return selected.some((v) => v !== NONE_VALUE);
      },
    },
    {
      id: "debts_loans_complete",
      layout: "full",
      textAlign: "center",
      hideButton: true,
      headerTitle: "",
      customComponent: createModuleComplete(),
    },
  ];
}
